module.exports = __webpack_public_path__ + "static/media/increase-sale.6eb6ef4a.png";